/**
 * @generated SignedSource<<731a34ca3d5740afb79a549d7f07adef>>
 * @relayHash db403e26dc09c83de39760fa9e0f2c68
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 94d06d52c4d32f1563bc3e9b931fbc637263547e3f92af1f2249fabdc6a289fc

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "%future added value";
export type JiraSetIssueSearchFieldSetsInput = {
  fieldSetsInput?: JiraIssueSearchFieldSets | null | undefined;
  viewId: string;
};
export type JiraIssueSearchFieldSets = {
  replaceFieldSetsInput?: JiraIssueSearchReplaceFieldSetsInput | null | undefined;
};
export type JiraIssueSearchReplaceFieldSetsInput = {
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  nodes: ReadonlyArray<string>;
};
export type JiraIssueSearchViewFieldSetsContext = {
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null | undefined;
  projectKey?: string | null | undefined;
};
export type main_setFieldSetsMutation$variables = {
  amountOfColumns: number;
  fieldSetsScope?: JiraIssueSearchScope | null | undefined;
  includeView: boolean;
  input: JiraSetIssueSearchFieldSetsInput;
};
export type main_setFieldSetsMutation$data = {
  readonly jira_setIssueSearchFieldSets: {
    readonly success: boolean;
    readonly view?: {
      readonly fieldSets: {
        readonly __id: string;
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly fieldSetId: string | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly totalCount: number | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"ui_nativeIssueTable_NativeIssueTable_columns">;
      } | null | undefined;
      readonly hasDefaultFieldSets: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type main_setFieldSetsMutation$rawResponse = {
  readonly jira_setIssueSearchFieldSets: {
    readonly success: boolean;
    readonly view: {
      readonly __typename: string;
      readonly fieldSets: {
        readonly __id?: string;
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly aliases: ReadonlyArray<string> | null | undefined;
            readonly displayName: string | null | undefined;
            readonly fieldSetId: string | null | undefined;
            readonly fieldSetPreferences: {
              readonly width: number | null | undefined;
            } | null | undefined;
            readonly fieldType: {
              readonly displayName: string | null | undefined;
            } | null | undefined;
            readonly fieldsMetadata: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly canBeConfigured: boolean | null | undefined;
                  readonly fieldId: string | null | undefined;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly isPlaceHolderField?: boolean | null | undefined;
            readonly isSortable: boolean | null | undefined;
            readonly jqlTerm: string | null | undefined;
            readonly type: string | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly totalCount: number | null | undefined;
      } | null | undefined;
      readonly hasDefaultFieldSets: boolean | null | undefined;
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type main_setFieldSetsMutation = {
  rawResponse: main_setFieldSetsMutation$rawResponse;
  response: main_setFieldSetsMutation$data;
  variables: main_setFieldSetsMutation$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": isJSCAliasChangesEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider: {
    readonly get: () => boolean;
  };
});

import isJscIFCEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-ifc-enabled.relayprovider';
import isJSCAliasChangesEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-alias-changes.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amountOfColumns"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsScope"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeView"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v4 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "success"
},
v6 = {
  "kind": "ScalarField",
  "name": "hasDefaultFieldSets"
},
v7 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "fieldSetSelectedState": "SELECTED"
    }
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "amountOfColumns"
  },
  {
    "kind": "Variable",
    "name": "scope",
    "variableName": "fieldSetsScope"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v9 = {
  "kind": "ScalarField",
  "name": "fieldSetId"
},
v10 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v11 = {
  "kind": "ScalarField",
  "name": "displayName"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "main_setFieldSetsMutation",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "JiraSetIssueSearchFieldSetsPayload",
        "kind": "LinkedField",
        "name": "jira_setIssueSearchFieldSets",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "condition": "includeView",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "view",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "args": (v7/*: any*/),
                    "concreteType": "JiraIssueSearchFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSets",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "concreteType": "JiraIssueSearchFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "ui_nativeIssueTable_NativeIssueTable_columns"
                      },
                      (v10/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "main_setFieldSetsMutation",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "JiraSetIssueSearchFieldSetsPayload",
        "kind": "LinkedField",
        "name": "jira_setIssueSearchFieldSets",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "condition": "includeView",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "view",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v6/*: any*/),
                  {
                    "args": (v7/*: any*/),
                    "concreteType": "JiraIssueSearchFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSets",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "concreteType": "JiraIssueSearchFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "type"
                              },
                              (v11/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "jqlTerm"
                              },
                              {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "aliases"
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isSortable"
                              },
                              {
                                "concreteType": "JiraFieldSetPreferences",
                                "kind": "LinkedField",
                                "name": "fieldSetPreferences",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "width"
                                  }
                                ]
                              },
                              {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldsMetadata",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueSearchMetadataField",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "canBeConfigured"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "fieldId"
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ClientExtension",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "isPlaceHolderField"
                                  }
                                ]
                              },
                              {
                                "concreteType": "JiraFieldType",
                                "kind": "LinkedField",
                                "name": "fieldType",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v10/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "94d06d52c4d32f1563bc3e9b931fbc637263547e3f92af1f2249fabdc6a289fc",
    "metadata": {},
    "name": "main_setFieldSetsMutation",
    "operationKind": "mutation",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": isJSCAliasChangesEnabled_provider
    }
  }
};
})();

(node as any).hash = "a1127b003eeb0f0b6c624a229c45326a";

export default node;
